import PropTypes from 'prop-types';
import styles from './FJUpgradeModal.module.less';
import FJModalClose from '../FJModalClose/FJModalClose';
import CreditIcon from '../../../assets/svg/credit.svg?react';
import AiIconIcon from '../../../assets/svg/ai-icon.svg?react';
import CalendarIcon from '../../../assets/svg/calendar.svg?react';
import PayIcon from '../../../assets/svg/pay.svg?react';
import FJIconButton from '../../../common/components/FJIconButton/FJIconButton';
import FJConstant from '../../../constants/FJConstant';
import FJConfig from '../../../config/FJConfig';
import FJLocalStore from '../../../store/FJLocalStore';

const infoList = [
    { text: 'credits-can-be-used-for-all-flexClip-ai-features', icon: <AiIconIcon /> },
    { text: 'valid-for-365-days-from-the-date-of-purchase', icon: <CalendarIcon /> },
    { text: 'one-time-payment', icon: <PayIcon /> },
];
const FJUpgradeModal = props => {
    const { onUpgrade, onClose } = props;

    return (
        <div className={styles.box}>
            <FJModalClose onClick={onClose} />
            <div className={styles.left}>
                <div className={styles.title}>{FJLocalStore._('purchase-credits-to-enjoy-ai-features')}</div>
                <div className={styles.desc}>
                    {FJLocalStore._('unlock-ai-features-and-release-unlimited-creativity')}
                </div>
                {infoList.map((info, index) => (
                    <div className={styles.info_box} key={index}>
                        {info.icon}
                        <span className={styles.info_text}>{FJLocalStore._(info.text)}</span>
                    </div>
                ))}

                <FJIconButton
                    text={FJLocalStore._('get-credits')}
                    onClick={onUpgrade}
                    icon={<CreditIcon className={styles.btn_icon} />}
                    isIconRight={true}
                    type={FJConstant.GET_CREDITS}
                    className={styles.btn}
                    textClassName={styles.btn_text}
                />
            </div>
            <div className={styles.right}>
                <img className={styles.upgrade_img} src={FJConfig.imgPath + 'upgrade.png'} alt='' loading='lazy' />
            </div>
        </div>
    );
};
FJUpgradeModal.propTypes = {
    onClose: PropTypes.func,
    onUpgrade: PropTypes.func,
};
export default FJUpgradeModal;
